import type {
  ApiRBACRoleItem,
  ApiRBACResponse,
  RBACMatrixFilters,
  RBACMatrixResponse,
  RBACMatrixRow,
  RBACMatrixDetails,
} from "../entities/RBACMatrix";

export class RBACMatrixMappers {
  static fromApiRoleItem(api: ApiRBACRoleItem): RBACMatrixRow {
    return {
      id: api.idRole,
      name: api.name,
      email: api.email ?? null,
      statut: api.statut ?? null,
      criticite: api.criticite ?? null,
      cadence: api.cadence ?? null,
      sod: api.sod,
    };
  }

  static fromApiResponse(
    api: ApiRBACResponse,
    page: number,
    rows: number,
  ): RBACMatrixResponse {
    const { items, totalElements } = api.data;
    const mappedItems = items.map((item) =>
      RBACMatrixMappers.fromApiRoleItem(item),
    );
    const totalPages = rows > 0 ? Math.ceil(totalElements / rows) : 0;
    const first = page === 0;
    const last = page >= totalPages - 1 || totalPages === 0;

    return {
      code: api.code,
      message: api.message,
      data: {
        items: mappedItems,
        totalElements,
        totalPages,
        first,
        last,
      },
    };
  }

  /** API uses offset=page (0-based page number), rows=page size, optional status */
  static toApiParams(filters: RBACMatrixFilters): {
    offset: number;
    rows: number;
    status?: string;
  } {
    const page = filters.page ?? 0;
    const size = filters.size ?? 20;
    const result: { offset: number; rows: number; status?: string } = {
      offset: page,
      rows: size,
    };
    if (filters.status) result.status = filters.status;
    return result;
  }

  static fromApiRoleDetails(api: RBACMatrixDetails): RBACMatrixDetails {
    return {
      id: api.id,
      name: api.name,
      email: api.email ?? null,
      description: api.description ?? null,
      owner: api.owner ?? null,
      nbrAssignation: api.nbrAssignation ?? 0,
      porte: api.porte ?? null,
      criticite: api.criticite ?? null,
      cadence: api.cadence ?? null,
      sod: api.sod,
      statut: api.statut ?? null,
      permissions: api.permissions ?? [],
    };
  }
}

export default RBACMatrixMappers;
